<template>
  <v-dialog v-model="show" width="50vw" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title> </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <span class="text-h5 lighten-2 black--text">
                Registro pesos
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header> Pesos </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-container fluid>
                      <v-form ref="formPresentation" lazy-validation>
                        <v-row>
                          <v-col>
                            <v-combobox outlined item-text="name" label="Selecciona presentación" return-object
                              clearable :items="presentations" v-model="presentation" dense
                              :rules="validation()"></v-combobox>
                          </v-col>
                          <v-col>
                            <v-btn color="primary" @click="addPresentation">
                              Guardar
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>

                      <v-row>
                        <v-col cols="12" xl="6" lg="6" md="6">
                          <span>
                            Estatus validación:
                            <div v-if="isValid != null">
                              <span v-if="isValid == true" class="primary--text">
                                Cumple
                              </span>
                              <span v-else class="red--text"> No cumple </span>
                            </div>
                            <div v-else>
                              <span>--</span>
                            </div>
                          </span>
                        </v-col>
                        <v-col cols="12" xl="6" lg="6" md="6" align="end">
                          <v-btn color="primary" rounded @click="showWeightModal">
                            <v-icon> mdi-weight </v-icon>
                            Agregar peso
                          </v-btn>
                        </v-col>

                        <v-col>
                          <span class="font-weight-bold">Presentación:
                            {{ presentation ? presentation.name : "-- g" }}
                          </span>
                          <v-spacer></v-spacer>
                          <span class="font-weight-bold">Peso ideal:
                            <div v-if="presentation">
                              <span v-if="presentation == '5 L'"> 4985 </span>
                              <span v-else-if="presentation.name == '250 g'">
                                255
                              </span>
                              <span v-else-if="presentation.name == '500 g'">
                                513
                              </span>
                              <span v-else-if="presentation.name == '2 kg'">
                                2021
                              </span>
                            </div>
                            <div v-else>
                              <span> -- g </span>
                            </div>
                          </span>
                          <v-spacer></v-spacer>
                          <span class="font-weight-bold">Peso promedio (g): {{ getAverage() }}
                          </span>
                          <v-spacer></v-spacer>
                          <span class="font-weight-bold">Diferencia con el ideal (g):
                            {{ difference() }}</span>

                          <v-data-table :headers="headers" :items="ptWeights" :items-per-page="5" class="elevation-1"
                            height="280px" fixed-header></v-data-table>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-expansion-panel-content> </v-expansion-panel></v-expansion-panels>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <span class="text-h5 lighten-2 black--text">
                Control calidad
              </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-switch label="`Se recibio la muestra" v-model="sampleDelivered"
                :disabled="isReadySampleDelivered"></v-switch>
              <v-btn color="primary" rounded @click="sampleDeliveryConfirmation" :loading="saveDelivereSample"
                v-if="!isReadySampleDelivered">
                <span> Guardar </span>
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="showAnalysis">
            <v-col cols="12" xl="3" lg="4">
              <v-btn color="primary" rounded block @click="addAnalsysis"
                :disabled="formulationSelected.isContaminatedColiforms" :loading="isAddingAnalysis">
                <v-icon>mdi-plus</v-icon>
                Agregar análisis
              </v-btn>
            </v-col>
            <v-col>
              <v-autocomplete label="Selecciona análisis" outlined dense v-model="selectedAnalysis" :items="validations"
                item-text="text" no-data-text="No hay análisis" clearable return-object></v-autocomplete>
            </v-col>
          </v-row>
          <!-- form analysis -->
          <div v-if="selectedAnalysis">
            <v-row v-if="!isFinished">
              <v-col align="end">
                <v-btn color="red" dark rounded @click="showConfirmationDelete = true" :loading="isDeletingAnalysis">
                  <v-icon> mdi-delete </v-icon>
                  Eliminar análisis
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field outlined label="Fecha análisis" type="date" dense v-model="analysisDate"
                  :disabled="isFinished"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field outlined label="Concentración" type="number" dense v-model="concentration"
                  :disabled="isFinished"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-col cols="12">
                  <v-row>
                    <v-col>
                      <span class="font-weight-bold">Morfologia colonial </span>
                    </v-col>
                  </v-row>
                  <div v-if="morphology">
                    <v-row v-if="loteSelected.moType == 'fungi'">
                      <v-col cols="12" sm="6">
                        <v-select v-model="morphology.obverse" outlined dense required label="Color anverso"
                          :items="fungiColor" :disabled="isFinished"></v-select>
                        <v-select v-model="morphology.reverse" outlined dense required label="Color reverso"
                          :items="fungiColor" :disabled="isFinished"></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select v-model="morphology.texture" outlined dense required label="Textura"
                          :items="fungiTexture" :disabled="isFinished"></v-select>
                        <v-select v-model="morphology.growth" outlined dense required label="Crecimiento"
                          :items="growth" :disabled="isFinished"></v-select>
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col cols="12" sm="6">
                        <v-select v-model="morphology.shape" clearable :items="shape" outlined dense required
                          label="Forma" :disabled="isFinished"></v-select>
                        <v-select v-model="morphology.margin" clearable :items="margin" outlined dense required
                          label="Borde" :disabled="isFinished"></v-select>
                        <v-select v-model="morphology.elevation" clearable :items="elevation" outlined dense required
                          label="Elevación" :disabled="isFinished"></v-select>
                      </v-col>
                      <v-col cols="12" sm="6">
                        <v-select v-model="morphology.surface" clearable :items="surface" multiple outlined dense
                          required label="Superficie" :disabled="isFinished">
                          <template v-slot:selection="{ item, index }">
                            <span v-if="index === 0" class="mr-2">{{
                              item.text
                            }}</span>
                            <span v-if="index === 1" class="grey--text caption">
                              ({{ morphology.surface.length - 1 }}
                              más)
                            </span>
                          </template>
                        </v-select>
                        <v-select v-model="morphology.opacity" clearable :items="opacity" outlined dense required
                          label="Opacidad" :disabled="isFinished"></v-select>
                        <v-select v-model="morphology.color" clearable :items="color" outlined dense required
                          label="Color" :disabled="isFinished"></v-select>
                      </v-col>
                    </v-row>
                  </div>
                  <div v-else>
                    <span>
                      HERE
                    </span>
                  </div>
                </v-col>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea v-model="observations" outlined name="input-7-4" label="Observaciones"
                  :disabled="isFinished"></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" xl="6" lg="6" md="6">
                <span>Presencia de contaminación</span>
                <v-spacer></v-spacer>
                <v-radio-group row v-model="isContaminated" :disabled="isFinished">
                  <v-radio :value="true" label="Presentes"></v-radio>
                  <v-radio :value="false" label="Ausentes"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" xl="6" lg="6" md="6" v-if="isContaminated">
                <v-text-field outlined dense label="Motivo de contaminación" v-model="pollutionReason"
                  :disabled="isFinished">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="!isFinished">
              <v-col cols="12" xl="4" lg="5" md="6">
                <v-btn color="gray" rounded dark class="mr-1" block @click="saveDataAnalysis">
                  Guardar
                </v-btn>
              </v-col>
              <v-col cols="12" xl="4" lg="5" md="6">
                <v-btn color="primary" rounded class="mr-1" block @click="showConfirmationFinish = true">
                  Finalizar análisis
                </v-btn>
              </v-col>
              <v-col cols="12" xl="4" lg="5" md="6">
                <v-btn color="red" rounded dark class="ml-1" block :loading="isLoadingContaminatedColiforms"
                  @click="showConfirmationColiforms = true">
                  Contaminación coliformes
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn color="gray" block @click="closeModal" dark>Cerrar</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <ConfirmationFinish v-model="showConfirmationFinish" @confirmation="finishDataAnalysis"
      :title="'¿Estás seguro(a) que quieres terminar este análisis?'" />
    <ConfirmationDelete v-model="showConfirmationDelete" @confirmation="deleteAnalysis"
      :title="'¿Estás seguro(a) que quieres eliminar este análisis?'" />
    <ConfirmationColiforms v-model="showConfirmationColiforms" @confirmation="makeContaminatedFormulation"
      :title="'¿Estás seguro(a) que quieres desechar esta formulación?'" />

    <QualityWeights v-model="showQualityWeights" v-if="showQualityWeights" @fetchData="updateFormulation" />
  </v-dialog>
</template>

<script>
//vuex
import { mapState, mapMutations, mapActions } from "vuex";
// components
import ConfirmationFinish from "@/components/utils/GenericConfirmationModal.vue";
import ConfirmationDelete from "@/components/utils/GenericConfirmationModal.vue";
import ConfirmationColiforms from "@/components/utils/GenericConfirmationModal.vue";
import QualityWeights from "@/components/dashboard/lote/modals/QualityWeights.vue";
//validations
import { requiredValidation } from "@/helpers/validations.js";
export default {
  components: {
    ConfirmationFinish,
    ConfirmationDelete,
    ConfirmationColiforms,
    QualityWeights,
  },
  data: () => ({
    presentation: null,
    presentations: [],
    presentationsS: [
      { name: "250 g", value: "250", units: "g" },
      { name: "500 g", value: "500", units: "g" },
      { name: "2 kg", value: "2000", units: "g" },
    ],
    presentationsL: [
      { name: "5 L", value: "5000", units: "ml" },
    ],
    isValid: null,
    loader: false,
    isLoading: false,
    sampleDelivered: false,
    isReadySampleDelivered: false,
    showAnalysis: false,
    selectedAnalysis: null,
    saveDelivereSample: false,
    validations: [],
    analysisDate: null,
    concentration: null,
    morphology: null,
    isContaminated: false,
    observations: "",
    pollutionReason: "",
    validationSelected: null,
    isFinished: false,
    isColiformes: false,
    showConfirmationFinish: false,
    isAddingAnalysis: false,
    showConfirmationDelete: false,
    isDeletingAnalysis: false,
    showConfirmationColiforms: false,
    isLoadingContaminatedColiforms: false,
    ptWeights: [],
    headers: [
      { text: "Nombre", value: "name", sortable: false },
      { text: "Peso", value: "weight", sortable: false },
    ],
    showQualityWeights: false,
  }),
  props: {
    value: Boolean,
  },
  computed: {
    ...mapState("lotes", ["formulationSelected", "loteSelected"]),
    ...mapState("strain", [
      "shape",
      "margin",
      "elevation",
      "surface",
      "opacity",
      "color",
      "fungiColor",
      "fungiTexture",
      "growth",
    ]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  async mounted() {
    await this.getFormulationRequest();
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("lotes", [
      "getFormulation",
      "setSampleDelivery",
      "getFormulationValidation",
      "saveValidationData",
      "finshValidationData",
      "addAnalysisValidation",
      "deleteAnalysisValidation",
      "setContaminatedFormulation",
      "setPresentationQuality",
    ]),
    ...mapActions("bioactives", ["getMorphology"]),
    closeModal() {
      this.show = false;
    },
    async sampleDeliveryConfirmation() {
      try {
        this.saveDelivereSample = true;
        let payload = {
          id: this.formulationSelected._id,
          sampleDelivered: this.sampleDelivered,
        };
        let response = await this.setSampleDelivery(payload);
        if (response) {
          this.setFormulation(response.formulation);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Información actualizada",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.saveDelivereSample = true;
    },
    async getFormulationRequest() {
      try {
        let payload = {
          id: this.formulationSelected._id,
        };
        let response = await this.getFormulation(payload);
        if (response) {
          this.setFormulation(response.formulation);
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async addAnalsysis() {
      try {
        this.isAddingAnalysis = true;
        let payload = {
          id: this.formulationSelected._id,
        };
        let response = await this.addAnalysisValidation(payload);
        if (response) {
          console.log(response);
          this.setFormulation(response.formulation);
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Analysis agregado",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isAddingAnalysis = false;
    },
    async deleteAnalysis() {
      try {
        this.isDeletingAnalysis = true;
        let payload = {
          formulationId: this.formulationSelected._id,
          validationId: this.validationSelected,
        };
        let response = await this.deleteAnalysisValidation(payload);
        if (response) {
          this.setFormulation(response.formulation);
          this.clean();
          this.$swal({
            icon: "success",
            title: `Análisis eliminado`,
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al eliminar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al eliminar`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isDeletingAnalysis = false;
    },
    async saveDataAnalysis() {
      try {
        let payload = {
          id: this.validationSelected,
          analysisDate: this.analysisDate,
          concentration: this.concentration,
          morphology: this.morphology,
          observations: this.observations,
          isContaminated: this.isContaminated,
          pollutionReason: this.pollutionReason,
        };

        let response = await this.saveValidationData(payload);
        if (response) {
          this.$emit("fetchData");
          this.SET_ALERT_TYPE({
            visible: true,
            type: "success",
            text: "Información guardada",
            timeout: 3500,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async finishDataAnalysis() {
      try {
        let payload = {
          id: this.validationSelected,
          analysisDate: this.analysisDate,
          concentration: this.concentration,
          morphology: this.morphology,
          observations: this.observations,
          isContaminated: this.isContaminated,
          pollutionReason: this.pollutionReason,
        };

        let response = await this.finshValidationData(payload);
        if (response) {
          this.$emit("fetchData");
          this.clean();
          this.$swal({
            icon: "success",
            title: `Análisis finalizado`,
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al guardar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al guardar`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
    async makeContaminatedFormulation() {
      try {
        this.isLoadingContaminatedColiforms = true;
        let payload = {
          formulationId: this.formulationSelected._id,
          validationId: this.validationSelected,
        };
        let response = await this.setContaminatedFormulation(payload);
        if (response) {
          this.setFormulation(response.formulation);
          this.clean();
          this.show = false;
          this.$swal({
            icon: "success",
            title: `Formulación desechada`,
            showConfirmButton: false,
            timer: 2000,
          });
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al eliminar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al eliminar`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isLoadingContaminatedColiforms = false;
    },
    setFormulation(item) {
      this.isReadySampleDelivered = item.isReadyToAnalysio;
      this.sampleDelivered = item.sampleDelivered;
      if (item.weights && item.weights.length > 0) {
        this.ptWeights = item.weights;
      }
      if (item.isReadyToAnalysio && item.sampleDelivered) {
        this.showAnalysis = true;
        this.validations = item.validations;
      }
      if (item.lineState == "S") {
        this.presentations = this.presentationsS;
      } else {
        this.presentations = this.presentationsL;
      }
      if (this.formulationSelected.presentationQuality) {
        this.presentation = this.formulationSelected.presentationQuality;
      }
    },
    getAverage() {
      if (this.ptWeights.length > 0) {
        let sum = this.ptWeights.reduce(
          (acumulator, number) => acumulator + parseInt(number.weight),
          0
        );
        let average = sum / this.ptWeights.length;
        return parseFloat(average).toFixed(2);
      } else {
        return 0;
      }
    },
    difference() {
      if (this.ptWeights.length > 0 && this.presentation) {
        let sum = this.ptWeights.reduce(
          (acumulator, number) => acumulator + parseInt(number.weight),
          0
        );
        let average = sum / this.ptWeights.length;
        let idealWeight = 0;
        let minWeight = 0;
        let maxWeight = 0;
        if (this.presentation.name == "5 L") {
          idealWeight = 4985;
          minWeight = 4725;
          maxWeight = 5245;
        } else if (this.presentation.name == "250 g") {
          idealWeight = 255;
          minWeight = 240;
          maxWeight = 270;
        } else if (this.presentation.name == "500 g") {
          idealWeight = 513;
          minWeight = 498;
          maxWeight = 528;
        } else if (this.presentation.name == "2 kg") {
          idealWeight = 2021;
          minWeight = 2006;
          maxWeight = 2036;
        }
        this.isValid = average >= minWeight && average <= maxWeight;
        return parseFloat(idealWeight - average).toFixed(2);
      } else {
        return 0;
      }
    },
    async mapValidations(item) {
      this.analysisDate = item.analysisDate;
      this.concentration = item.concentration;
      this.morphology = item.morphology;
      this.observations = item.observations;
      this.isContaminated = item.isContaminated ? item.isContaminated : false;
      this.pollutionReason = item.pollutionReason ? item.pollutionReason : "";
      this.validationSelected = item._id;
      this.isFinished = item.isFinished;
      await this.fillMorphology();
    },
    clean() {
      this.analysisDate = null;
      this.concentration = null;
      this.morphology = null;
      this.observations = null;
      this.isContaminated = false;
      this.pollutionReason = null;
      this.validationSelected = null;
      this.isFinished = false;
      this.selectedAnalysis = null;
    },
    async fillMorphology() {
      let baseMorphology = {};

      let response = await this.getMorphology({
        identification: this.loteSelected.identification,
      });
      if (response) {
        baseMorphology = response.mophologyFound;
        if (!baseMorphology) {
          baseMorphology = {
            obverse: "",
            reverse: "",
            texture: "",
            growth: "",
            surface: [],
            shape: "",
            margin: "",
            elevation: "",
            color: "",
            opacity: "",
            gram: false,
            KOH: false,
            catalase: false,
            oxidase: false,
          };
        }
      }

      if (response.identificationFound.moType === "fungi") {
        if (this.morphology) {
          if (
            (this.morphology.obverse || this.morphology.obverse.length == 0) &&
            (this.morphology.reverse || this.morphology.reverse.length == 0) &&
            (this.morphology.texture || this.morphology.texture.length == 0) &&
            (this.morphology.growth || this.morphology.growth.length == 0)
          ) {
            this.morphology = JSON.parse(JSON.stringify(baseMorphology));
          }
        } else {
          this.morphology = JSON.parse(JSON.stringify(baseMorphology));
        }

      } else if (response.identificationFound.moType === "bacteria") {
        if (this.morphology) {
          if (
            (this.morphology.shape || this.morphology.shape.length == 0) &&
            (this.morphology.margin || this.morphology.margin.length == 0) &&
            (this.morphology.elevation ||
              this.morphology.elevation.length == 0) &&
            (this.morphology.surface || this.morphology.surface.length == 0) &&
            (this.morphology.opacity || this.morphology.opacity.length == 0) &&
            (this.morphology.color || this.morphology.color.length == 0)
          ) {
            this.morphology = JSON.parse(JSON.stringify(baseMorphology));
          }
        } else {
          this.morphology = JSON.parse(JSON.stringify(baseMorphology));
        }
      }
    },
    showWeightModal() {
      this.showQualityWeights = true;
    },
    async updateFormulation() {
      this.showQualityWeights = false;
      await this.getFormulationRequest();
      this.$emit("fetchData");
    },
    validation(name) {
      return requiredValidation(name);
    },
    async addPresentation() {
      if (this.$refs.formPresentation.validate()) {
        let payload = {
          presentation: this.presentation,
          formulationId: this.formulationSelected._id,
        };
        let response = this.setPresentationQuality(payload);
        if (!response) throw response;
        this.$emit("fetchData");
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Información actualizada",
          timeout: 3500,
        });
      }
    },
  },
  watch: {
    async selectedAnalysis(value) {
      if (!value) return;

      try {
        let payload = {
          id: value.value,
        };
        let response = await this.getFormulationValidation(payload);
        if (response) {
          await this.mapValidations(response.formulationValidation);
        } else {
          this.$swal({
            icon: "error",
            title: `Algo salio mal al cargar`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
      } catch (error) {
        console.log(error);
        this.$swal({
          icon: "error",
          title: `Algo salio mal al cargar`,
          showConfirmButton: false,
          timer: 2000,
        });
      }
    },
  },
};
</script>
